import { addDataLayerEntry } from '@printdeal/data-layer-manager';

export const dispatchDataLayerEventOnSearchInteractionGA4 = (action: string) => {
  addDataLayerEntry(
    'search_interaction',
    { action },
  );
};
